import { ErrorHandler, Injectable } from '@angular/core';
import { isChunkLoadError } from './is-chunk-load-error';
import { reloadOnce } from './reload-once';

/**
 * Reloads the page on a failure to load a lazily loaded code file outside a navigation, as
 * happens in a tab opened before a deployment that deleted the file; a full page load brings the
 * latest release.
 *
 * On a failed navigation, ReleaseCheckService has already sent the tab to the page the user
 * asked for, so this does nothing. Every other error, and a failure that the loop guard of
 * reloadOnce did not reload for, goes to Angular's default handling, which logs it.
 */
@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (isChunkLoadError(error) && reloadOnce(window.location.href, 'chunk-load-error')) {
      return;
    }
    super.handleError(error);
  }
}
